import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DownloadCSVFile } from "./FileDownloadManager";
import {
  renderSortableColumn,
  renderSetFilterInputColumn,
  renderSetFilterSelectColumn,
} from "./ColumnManager";

export const renderFilterCellLots = (
  col,
  idx,
  context
) => {
  switch (col.FilterType) {
    case "select":
      const options = context.uniqueValuesByKey?.[col.key];
      return renderSetFilterSelectColumn(
        context,
        col.key,
        options,
        col.key,
        col.label
      );


    case "input":
      return renderSetFilterInputColumn(
        context,
        col.key,
        col.colSpan,
        col.placeHolder,
        col.filterKey
      );

    case "sort":
      return renderSortableColumn(context, col.key, col.key);

    case "ActionFilter":
      return (
        <th
          key={`filter-action-${idx}`}
          style={{
            backgroundColor: context.colorFilterAction,
          }}
          className="ClassActionFilter style_tbody_th"
        >
          <div style={{ display: "flex" }}>
            <div>
              <DownloadCSVFile data={context.data} />
            </div>
            <button
              data-toggle="tooltip"
              title={context.t("Reset filters")}
              onClick={context.handleResetFilters}
              className="btn bg-light text-hover-blue"
              style={{ marginRight: "3px", marginLeft: "3px" }}
            >
              RAZ
            </button>
            <button
              data-toggle="tooltip"
              title={context.t("Reload page")}
              className="btn bg-light"
              onClick={() => window.location.reload(false)}
            >
              <FontAwesomeIcon icon={faArrowRotateRight} className="fa-copy" />
            </button>
          </div>
        </th>
      );

    default:
      return (
        <th
          key={`filter-default-${idx}`}
          className="style_tbody_th"
          style={{ backgroundColor: context.colorFilterAction }}
        ></th>
      );
  }
};
